export enum AppRoutes {
  main = '/',
  alerts = '/alerts',
  respondentInterviews = '/respondent-interviews',
  interviews = '/interviews',
  appSettings = '/app-settings',
  feedbacks = '/feedbacks',
  login = '/login',
  oneTimeLink = '/one-time-link',
  oneTimeToken = '/one-time-token',
  test = '/test',
  workspaces = '/workspaces',
  userInvite = '/user/invite',
  dashboard = '/dashboard',
  settings = '/settings',
  policy = '/privacy-policy',
  terms = '/terms-and-conditions',
  conversationStartersManagement = '/conversation-starters-management',
  systemAdminDashboard = '/system-admin-dashboard',
  toolManagement = '/tool-management',
  productManagement = '/product-management',
  flows = '/flows',
  inductionCategories = '/induction-categories',
  workspaceAllSpaces = '/all-spaces'
}
